import {twJoin, twMerge} from 'tailwind-merge';
import {getBrandStyleCSS} from 'src/utils/getBrandStyle';
import RemixIcon from './RemixIcon';

type Props = {
  brandStyle: BrandStyle;
  value: boolean;
  style?: React.CSSProperties;
  className?: string;
  size?: number;
};

const Checkbox = ({brandStyle, value, style, className, size = 24}: Props) => {
  const brandCss = getBrandStyleCSS(brandStyle);

  return (
    <div
      style={{width: size, height: size, ...brandCss, ...style}}
      className={twMerge(
        'shrink-0 w-6 h-6 rounded-full flex relative justify-center items-center bg-transparent [&_svg]:fill-white transition-shadow',
        value ? 'shadow-[inset_0_0_0_20px_var(--brand-primary-color)]' : 'shadow-[inset_0_0_0_2px_#929292]',
        className
      )}
    >
      <div className={twJoin('origin-center transition-transform', value ? 'scale-100' : 'scale-0')}>
        <RemixIcon name="check-line" size={size * 0.75} />
      </div>
    </div>
  );
};

export default Checkbox;
